import { FileObj } from 'components/FileUploads';

interface ConsentForms {
  signedBy: string;
  signedDate: string;
  relationshipToPatient: string;
  phoneNumber: string;
  docName: string;
  docAliasId: string;
  witness: string;
}

export interface SLA {
  state: string;
  message: string;
}

export interface EVisitFormData {
  forms: ConsentForms[];
  sla: SLA;
}

export interface InsurancePatient {
  address: string;
  birthDate: string;
  city: string;
  email: string;
  firstName: string;
  lastName: string;
  phone: string;
  state: string;
  zipCode: string;
}

export interface InsurancePolicy {
  memberId: number;
  planNetwork: string;
  priority: number;
  profileName: string;
  subscriberDateOfBirth: string;
  subscriberFullName: string;
  subscriberGender: 'Female' | 'Male' | 'Other' | 'Prefer not to respond';
  subscriberId: string;
  subscriberRelationship: 'Self' | 'Other';
}

export interface UserInsuranceInfo {
  patient: InsurancePatient;
  policy?: InsurancePolicy;
}

export type UploadCardStatus = 'pending' | 'processing' | 'success' | 'error';

export interface InsuranceFile {
  file?: FileObj | null;
  insuranceType: keyof InsuranceFileState;
  attachmentId?: string | null;
  azureFileName?: string | null;
  status?: UploadCardStatus;
  errorMessage?: string | null;
  isFetching?: boolean;
}

export interface InsuranceFileState {
  primaryFront: InsuranceFile;
  primaryBack: InsuranceFile;
  secondaryFront: InsuranceFile;
  secondaryBack: InsuranceFile;
}

export interface UploadInsuranceFilePayload {
  payload?: {
    data?: InsuranceFile;
  };
  error?: string;
}

export interface UploadInsuranceFileResponse {
  attachmentId?: string;
  azureFileName?: string;
  error?: string | null;
}

export interface SubscriberDetailsDTO {
  id: string;
  planNetwork: string;
  planNumber: string;
  fullName: string;
  dateOfBirth: string;
  address: string;
  phone: string;
  gender: string;
  relationship: string;
}

export enum CardPosition {
  FRONT = 'FRONT',
  BACK = 'BACK'
}

export interface CardUploadImage {
  name: string;
  position: CardPosition;
}

export interface InsuranceCardUpload {
  images: CardUploadImage[];
  type: string;
}
export interface InsurancesUpload {
  subscriberDetails: SubscriberDetailsDTO;
  insuranceCards: InsuranceCardUpload[];
}

export interface InsuranceData {
  firstName: string;
  lastName: string;
  phoneNumber: string;
  email: string;
  birthDate: Date | string;
  subscriberId: string;
  planNetwork: string;
  planNumber: string;
  address: string;
  subscriberFullName: string;
  subscriberDateOfBirth: string;
  subscriberRelationship: string;
  subscriberGender: string;
}

export interface AttachmentUploadResponseInterface {
  actionStatus: string;
  attachmentId: string;
  azureFileName?: string;
}

export interface ImageInfo {
  primaryFront?: string;
  primaryBack?: string;
  secondaryFront?: string;
  secondaryBack?: string;
}
